/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react'
import { BannerHome } from './BannerHome'
import { BoxSearch } from './BoxSearch'
import { AboutSection } from './AboutSection'
import { CatalogsSection } from './CatalogsSection'
import { ProductSale } from './ProductSale'
import { OnWorld } from './OnWorld'
import { ProductUs } from './ProductUs'
import { DiarySection } from './DiarySection'
import { CustomerRate } from './CustomerRate'
import { useQuery } from 'react-query'
import { graphQLClientGET } from '~src/api/graphql'
import { GET_CONTENT_HOME_PAGE } from '~src/api'
import { GET_DEFAULT_FILTER } from '~src/api/categories'

export const HomePage = () => {
  // GET_CONTENT_HOME_PAGE
  const { data } = useQuery({
    queryKey: ['getContentHomePage'],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_CONTENT_HOME_PAGE, {
        identifiers: [
          'home-page-banner',
          'home-page-branchs',
          'home-page-services',
          'info-contact',
          // 'home-page-customer-reviews',
        ],
      })) as {
        snowdogMenus: any
      }
      return data?.snowdogMenus
    },
    cacheTime: Infinity,
  })

  // Filter default
  const { data: defaultWebsiteFilter, isLoading: isLoadingDefaultWebsiteFilter } = useQuery<
    TDefaultWebsiteFilter,
    Error
  >({
    queryKey: ['GET_DEFAULT_FILTER'],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_DEFAULT_FILTER)) as {
        defaultWebsiteFilter: TDefaultWebsiteFilter
      }
      return data.defaultWebsiteFilter
    },
  })

  return (
    <div className="home-page">
      <BannerHome data={data} />
      <BoxSearch
        defaultFilter={defaultWebsiteFilter}
        loadingFilter={isLoadingDefaultWebsiteFilter}
      />
      <AboutSection data={data} />
      <CatalogsSection id={defaultWebsiteFilter?.nhom_phu_tung || ''} />
      <ProductSale />
      <OnWorld dataBrand={data} />
      <ProductUs />
      <DiarySection />
      <CustomerRate />
    </div>
  )
}
